export default "__VITE_ASSET__C2jl$Mrt__"